<template>
  <div class="frontpage">
    <Header />
    <v-container>
      <v-row class="my-4">
        <v-col v-if="this.updatedata == true" class="col-8 col-sm-6 col-md-12 col-lg-12 mx-auto">
           <v-alert
              outlined
              color="primary"
              align="center"
              justify="center"
              dense
            >
            <v-row align="center">
                <v-col class="grow white--text">
                  Update Match Ups
                </v-col>
                <v-col class="shrink">
                  
                  <v-btn 
                  class="closeupdate"
                  depressed
                  text
                  small
                  @click="setupdatetofalse()"
                  >
                  <v-icon color="primary">
                      mdi-refresh
                    </v-icon>
                  </v-btn>
                </v-col>
              </v-row>
            </v-alert>
        </v-col>
        <v-col v-if="todayfights == ''" class="col-12">
              <v-alert outlined type="warning" color="primary" class="text-center">
                No Fights available
            </v-alert>
          </v-col>
        <v-col class="col-12">
          <!-- {{this.fightsdata}} -->
           <v-card v-for="fight in todayfights" :key="fight.uid" class="my-5 py-5" dark>
                  <v-row>
                    <v-col class="text-center col-12 col-sm-12 col-md-4 sol-lg-4">
                      <v-row>
                        <v-col class="col-12 text-center">
                        <v-avatar size="100">
                            <img :src="fight.Fighter1Image" alt="John" />
                          </v-avatar>
                          <h3>{{ fight.Fighter1Name }} {{ fight.Fighter1SurName }}</h3>
                          <!-- <h4>{{ fight.Fighter1Percentage }}</h4> -->
                        </v-col>
                      </v-row>
                    </v-col>
                  <v-col class="text-center col-12 col-sm-12 col-md-4 sol-lg-4">
                      <!-- Start Date -->
                    <h4>{{ fight.DateStart}}</h4>
                    <h2>VS</h2>
                    Voting Ends
                    <h4>{{ fight.DateEnd}}</h4>
                    <v-btn
                    class="mt-3 primary"
                      elevation="2"
                      @click="viewfighter(fight.Fightuid, fight.FightTitle, fight)"
                    >
                    <!-- <router-link :to="/foo/${fight.Fightuid}" tag="button">foo</router-link> -->
                    Vote Now
                    </v-btn>
                  </v-col>
                    <v-col class="text-center col-12 col-sm-12 col-md-4 sol-lg-4">
                      <v-row>
                        <v-col class="col-12">
                        <v-avatar size="100">
                            <img :src="fight.Fighter2Image" alt="John" />
                          </v-avatar>
                          <h3>{{ fight.Fighter2Name }} {{ fight.Fighter2SurName }}</h3>
                          <!-- <h4>{{ fight.Fighter2Percentage }}</h4> -->
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-card>
        </v-col>
        <v-col class="col-3">
        </v-col>
      </v-row>
    </v-container>
    <Footer/>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import Header from "../components/frontend/header.vue";
import Footer from "../components/frontend/footer.vue"

export default {
  data: () => ({
    mysecondfighterdatas: [],
    myfirstfighterdatas: [],
    fightstoday:[],
    fights: [],
    heyyy:false,
    tab: null,
    // show: false
  }),
  components: { Header, Footer },
  computed: {
    ...mapGetters(['fightsdata', 'todayfights', 'upcomingfights', 'pastfightsfights', 'updatedata'])
  },
  created() {
    this.heyyyy()
  },
  methods: {
    heyyyy() {
      if(this.updatedata) {
        console.log('updatedata on page', this.updatedata)
      }
    },
    setupdatetofalse(){
      this.$store.dispatch('setdataupdatetofalse')
    },
     viewfighter(uid, FightTitle, fight) {
       let zayzay =  FightTitle.replaceAll(' ', '-').toLowerCase();
      this.$router.push({
          name: 'FightPage',
          params: {
              FightTitle:zayzay,
              uid: uid,
              fight:fight
          }
      })
    },
  },
};
</script>

<style lang="sass">
.closeupdate
  background-color: transparent !important
</style>